export default __webpack_public_path__ + "static/media/cobra-io.9f38bafd.md";